import uniqueId from "lodash/uniqueId";

export function install(Vue, {store}) {
    Vue.component('queue-receiver', require('../components/QueueReceiver').default);

    store.registerModule('queue', require('../modules/queueModule').default);

    Vue.$queue = Vue.prototype.$queue = {
        push(ns, data = {}, listeners = {}) {
            let id = uniqueId();  // needed for transitions and closing
            store.commit('queue/push', {ns, id, data, listeners});
            return () => store.commit('queue/remove', {ns, id});
        },
        get: (ns, count) => store.getters['queue/get']({ns, count}),
        getCount: ns => store.getters['queue/getCount'](ns),
    };
}